/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadDocumentStats } from './LeadDocumentStats';
import {
    LeadDocumentStatsFromJSON,
    LeadDocumentStatsFromJSONTyped,
    LeadDocumentStatsToJSON,
    LeadDocumentStatsToJSONTyped,
} from './LeadDocumentStats';

/**
 * 
 * @export
 * @interface FindLeadsBatchWithDocumentStats200Response
 */
export interface FindLeadsBatchWithDocumentStats200Response {
    /**
     * 
     */
    data?: Array<LeadDocumentStats>;
}

/**
 * Check if a given object implements the FindLeadsBatchWithDocumentStats200Response interface.
 */
export function instanceOfFindLeadsBatchWithDocumentStats200Response(value: object): value is FindLeadsBatchWithDocumentStats200Response {
    return true;
}

export function FindLeadsBatchWithDocumentStats200ResponseFromJSON(json: any): FindLeadsBatchWithDocumentStats200Response {
    return FindLeadsBatchWithDocumentStats200ResponseFromJSONTyped(json, false);
}

export function FindLeadsBatchWithDocumentStats200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindLeadsBatchWithDocumentStats200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(LeadDocumentStatsFromJSON)),
    };
}

export function FindLeadsBatchWithDocumentStats200ResponseToJSON(json: any): FindLeadsBatchWithDocumentStats200Response {
    return FindLeadsBatchWithDocumentStats200ResponseToJSONTyped(json, false);
}

export function FindLeadsBatchWithDocumentStats200ResponseToJSONTyped(value?: FindLeadsBatchWithDocumentStats200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(LeadDocumentStatsToJSON)),
    };
}

